<div class="position-in-route-editor">
    <div class="row">
      <mat-form-field class="mat-form-field-readonly flex-grow">
        <input matInput [(ngModel)]="positionName"
          placeholder="{{'position in route' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.position-in-route-editor.position-in-route', translationService.language]}}"
          [readonly]="true">
      </mat-form-field>
  
      <button mat-flat-button type="button" (click)="assignNextProcessingPosition()" class="small-button assign-button"><i
          class="fa-light fa-sitemap"></i></button>
    </div>
  </div>